import pageMeta from 'pageMeta/pageMeta';
import fixHref from './fix-href';

/**
 * prepends 'affiliateId=tdl-' for MLB.com links and adds 'tfl=' for non-MLB.com links
 * @param {string} hrefString - url that tfl is being appended to
 * @param {string} tfl - the tfl params that were generated by makeTFL()
 * @returns {string}
 */
function addPrefix(hrefString, tfl) {
    const isInternalLink = !(/^https?:\/\//.test(hrefString)) ||
        (/.mlb.com/.test(hrefString.replace(/^(https?:)?\/\//, '').split('/')[0]));
    const prefix = isInternalLink ? 'affiliateId' : 'tfl';
    const tdl = isInternalLink ? 'tdl-' : '';
    return `${prefix}=${tdl}${tfl}`;
}

/**
 * Generates a TFL string - can be accessed locally or via window.makeTFL
 * @param {object} params keys are 'url', 'component' and 'location' - used to set dynamic TFL params
 * If in params returnWholeUrl is true then complete url is returned and can be used as it is
 * @returns {string}
 */
export default function makeTFL(params) {
    const omnitureData = window.adobeAnalytics;
    const metaPageName = pageMeta.page_name || '';
    let page;
    let device;
    let view;
    let url;
    let componentParam;
    let locationParam;
    let returnWholeUrl;

    if (params) {
        if (params.url) {
            url = params.url;
        }
        if (params.component) {
            componentParam = params.component;
        }
        if (params.location) {
            locationParam = params.location;
        }
        if(params.returnWholeUrl) {
        	returnWholeUrl = true;
        }
    }

    if (omnitureData) {
        if (omnitureData.eVar34) {
            device = omnitureData.eVar34;
        } else {
            if (omnitureData.prop15) {
                device = omnitureData.prop15.substr(0, omnitureData.prop15.indexOf(':'));
            } else {
                device = 'unknown';
            }
        }
        if (omnitureData.eVar35) {
            view = omnitureData.eVar35;
        } else {
            if (omnitureData.prop15) {
                view = omnitureData.prop15.substr(omnitureData.prop15.indexOf(':') + 2, omnitureData.prop15.length);
            } else {
                view = 'unknown';
            }
        }
        if (omnitureData.pageName) {
            page = omnitureData.pageName;
        } else {
            page = metaPageName;
        }
    }

    const finalParams = [
        pageMeta.page_name || 'unknown',
        pageMeta.page_section || 'unknown',
        page || 'na',
        componentParam || 'na',
        locationParam || 'x0',
        device || 'unknown',
        view || 'unknown'
    ].map((_) => _.replace(/(\s|-)/g, '_') || 'na').join('-');

    if(url && returnWholeUrl) {
    	return fixHref(url , addPrefix(url, finalParams));
    } else if (url) {
        return addPrefix(url, finalParams);
    }

    return finalParams;

}
